import * as React from "react";
import { useEventCallback } from "@vingle/wtf-sdk/helpers/hook";

export default function useDiscoverSlideHook(
  data: any[],
  moveSize: number,
  showSize?: number,
) {
  const showSizeValue = showSize || moveSize;
  const [slidePosition, setSlidePosition] = React.useState(0);
  const isDisabledPrev = React.useMemo(() => slidePosition === 0, [
    slidePosition,
  ]);
  const maxPosition = React.useMemo(() => {
    return (
      showSizeValue * (Math.floor(data.length / showSizeValue) - 1) +
      (data.length % showSizeValue)
    );
  }, [data]);
  const isDisabledNext = React.useMemo(() => slidePosition === maxPosition, [
    slidePosition,
    data,
  ]);
  const handleMoveDirection = React.useCallback(
    (direction: -1 | 1) => {
      if (direction === -1 ? isDisabledPrev : isDisabledNext) {
        return;
      }
      setSlidePosition(prevSlidePosition => {
        const newSlidePosition = prevSlidePosition + moveSize * direction;
        return direction === -1
          ? newSlidePosition < 0
            ? 0
            : newSlidePosition
          : newSlidePosition > maxPosition
          ? maxPosition
          : newSlidePosition;
      });
    },
    [isDisabledPrev, isDisabledNext, data],
  );
  const handleMovePrev = useEventCallback((event: React.MouseEvent) => {
    event.preventDefault();
    handleMoveDirection(-1);
  });
  const handleMoveNext = useEventCallback((event: React.MouseEvent) => {
    event.preventDefault();
    handleMoveDirection(1);
  });
  const slideStyle = React.useMemo(
    () => ({
      transform: `translate3d(-${slidePosition * 100}%, 0, 0)`,
    }),
    [slidePosition],
  );
  return {
    slidePosition,
    isDisabledPrev,
    isDisabledNext,
    handleMovePrev,
    handleMoveNext,
    slideStyle,
  };
}
